__turbopack_context__.v({
  "back": "rVh3lq_back",
  "chevron": "rVh3lq_chevron",
  "footerStack": "rVh3lq_footerStack",
  "list": "rVh3lq_list",
  "row": "rVh3lq_row",
});
